import { RoutePaths } from '../../../../interfaces/enums';
import { IMainMenuItem } from '../mainMenu/IMainMenu';

export const adviser: IMainMenuItem = {
    itemGroups: [
        {
            headerCode: null,
            items: [
                {
                    href: RoutePaths.GeneralContacts,
                    resource: 'AnelmaInfo',
                    scope: 'LIST',
                    textCode: 1014,
                },
            ],
        },
        {
            headerCode: null,
            items: [
                {
                    href: RoutePaths.InfoInstructionsAndCode,
                    resource: 'AnelmaInfo',
                    scope: 'LIST',
                    textCode: 1041,
                },
            ],
        },
        {
            headerCode: null,
            items: [
                {
                    href: RoutePaths.InfoMP,
                    resource: 'AnelmaInfo',
                    scope: 'LIST',
                    textCode: 1042,
                },
            ],
        },
        {
            headerCode: null,
            items: [
                {
                    href: RoutePaths.InfoFeeding,
                    resource: 'AnelmaInfo',
                    scope: 'LIST',
                    textCode: 1043,
                },
            ],
        },
        {
            headerCode: null,
            items: [
                {
                    href: RoutePaths.InfoLab,
                    resource: 'AnelmaInfo',
                    scope: 'LIST',
                    textCode: 1044,
                },
            ],
        },
        {
            headerCode: null,
            items: [
                {
                    href: RoutePaths.InfoShop,
                    resource: 'AnelmaInfo',
                    scope: 'LIST',
                    textCode: 1045,
                },
            ],
        },
    ],
    textCode: 1015,
};
